import React, { useState } from 'react';
import { Box, Container, Typography } from '@mui/material'; 
import { motion } from 'framer-motion';

// Képek importálása
// @ts-ignore
import ajandekImg from '../videos/ajandek.PNG'; 
// @ts-ignore
import boltivImg from '../videos/boltiv.png'; 

const Gifts: React.FC = () => {
  const [showIban, setShowIban] = useState(false);

  return (
    <Box 
      sx={{ 
        backgroundColor: 'primary.main', 
        py: { xs: 8, md: 15 }, // Mobilon picit kisebb külső térköz, hogy több hely legyen
        textAlign: 'center' 
      }}
    >
      <Container maxWidth="lg"> {/* VÁLTOZÁS: md-ről lg-re növeltük a konténert, hogy a 800px-es keret elférjen */}
        <motion.div 
          initial={{ opacity: 0, scale: 0.95 }} 
          whileInView={{ opacity: 1, scale: 1 }} 
          viewport={{ once: true }} 
          transition={{ duration: 0.8 }}
        >
          
            
            {/* === BELSŐ TARTALOM === */}
            <Box sx={{ p: 0, width: '100%' }}>
              
              <Box sx={{ mb: { xs: 2, md: 4 }, display: 'flex', justifyContent: 'center' }}>
                <Box 
                  component="img"
                  src={ajandekImg}
                  alt="Ajándék"
                  sx={{
                    width: { xs: 55, md: 80 }, // Ajándék mérete asztalin nagyobb
                    height: 'auto',
                    objectFit: 'contain'
                  }}
                />
              </Box>
              
              <Typography variant="h2" sx={{ 
                color: '#ffffff', 
                fontSize: { xs: '3rem', md: '5.5rem' }, // Asztalin óriási, elegáns főcím
                mb: { xs: 2, md: 3 }
              }}>
                Ajándék
              </Typography>
              
              <Typography variant="h6" sx={{ 
                mb: 2, 
                fontWeight: 300, 
                lineHeight: { xs: 1.8, md: 2.2 }, // Asztalin levegősebb sorköz
                color: 'text.secondary', 
                fontStyle: 'italic',
                fontSize: { xs: '0.95rem', md: '1.35rem' } // Mobilon optimális, asztalin jól olvasható nagy méret
              }}>
                Aki nászunkra szép ajándékot adna,<br />
                A ránk szánt összeget tegye borítékba,<br />
                A legtöbbet ezzel segít nekünk,<br />
                Támogatva induló közös életünk.<br />
                És, hogy a szerencse minket el ne hagyjon,<br />
                Érkezéskor minden kedves vendég<br />
                egy sorsjegyet adjon!
              </Typography>

            </Box>

        </motion.div>
      </Container>
    </Box>
  );
};

export default Gifts;